// extracted by mini-css-extract-plugin
export default {"disputeRow":"DisputeRow_disputeRow__p+PQe"};